import { Injectable } from '@angular/core';
import { IRegistryFrontendService } from '@fui/map-library';

@Injectable()
export class RegistryFrontendService implements IRegistryFrontendService {
    public readonly REGISTER_CARD_URL = 'https://front.dev.fplatform.ifarwater.ru/factor/input/row';
    public readonly BIND_WITH_MAP = 'https://front.dev.fplatform.ifarwater.ru/bind-with-map';
}
